import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

// Resolve intake base URL at runtime so a missing build-time env var doesn't
// silently leak the QA host into prod builds. Order:
//   1. explicit REACT_APP_INTAKE_BASE_URL (test/dev override)
//   2. host-based detection — connect.* → prod intake, anything else → QA
function resolveIntakeBaseUrl() {
  if (process.env.REACT_APP_INTAKE_BASE_URL) return process.env.REACT_APP_INTAKE_BASE_URL;
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const host = window.location.hostname;
    if (host === 'connect.newtonhealthcore.com') return 'https://intake.newtonhealthcore.com';
  }
  return 'https://intake-qa.newtonhealthcore.com';
}
const INTAKE_BASE_URL = resolveIntakeBaseUrl();

export default function IntakeQRCode({ accessToken, size = 180 }) {
  const [copied, setCopied] = useState(false);

  if (!accessToken) return null;

  const url = `${INTAKE_BASE_URL}/intake?access_token=${accessToken}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* fallback for older browsers */ }
  };

  return (
    <div style={styles.container}>
      <QRCodeSVG value={url} size={size} level="M" />
      <p style={styles.label}>Scan to fill intake forms</p>
      <button onClick={handleCopy} style={styles.copyBtn}>
        {copied ? 'Copied!' : 'Copy Intake Link'}
      </button>
    </div>
  );
}

const styles = {
  container: { textAlign: 'center', padding: '12px 0' },
  label: { margin: '8px 0 0', fontSize: '0.8rem', color: '#6B7280' },
  copyBtn: {
    marginTop: 8, padding: '6px 16px', fontSize: 12, fontWeight: 500,
    border: '1px solid #d1d5db', borderRadius: 6, background: '#fff',
    color: '#374151', cursor: 'pointer',
  },
};
